import {FeatureLayerProperties, GRAPHIC_ATTRS, GRAPHIC_ATTR_IDS} from "../../models";
import {LABELING_INFO_SYMBOL, OBJECTID} from "../map";
import {MapLayerColor, MapTool} from "../../enums";
import {ChacraGeoFrom, DibujoType} from "../../../../chacra-core/models";

export const CHACRAS_LAYER: FeatureLayerProperties = {
  name: 'chacra',
  title: 'Chacra',
  objectIdField: OBJECTID,
  geometryType: DibujoType.POLYGON,
  spatialReference: {wkid: 4326},
  outFields: ['*'],
  fields: [
    {name: 'graphicAttr', alias: 'Graphic Attr Type', type: 'string'},
    {name: 'featureName', alias: 'Feature Name', type: 'string'},
    {name: 'chacraId', alias: 'Chacra Id', type: 'string'},
    {name: 'chacraNro', alias: 'Chacra Nro', type: 'string'},
    {name: 'chacraNombre', alias: 'Chacra Nombre', type: 'string'},
    {name: 'chacraLocalidad', alias: 'Localidad', type: 'string'},
    {name: 'chacraArea', alias: 'Area', type: 'double'},
    {name: 'chacraDicose', alias: 'DICOSE', type: 'string'},
    {
      name: 'chacraFactorLSEsManual',
      alias: 'Pendiente Manual',
      type: 'string'
    },
    {name: 'chacraFactorLSAsignado', alias: 'LS elegido', type: 'double'},
    {name: 'chacraFactorLSLimitante', alias: 'LS limitante', type: 'double'},

    {name: 'chacraSueloAsignadoFactorK', alias: 'K elegido', type: 'double'},
    {
      name: 'chacraSueloLimitanteFactorK',
      alias: 'K limitante',
      type: 'double'
    },
    {
      name: 'chacraSueloAsignadoId',
      alias: 'Id suelo elegido',
      type: 'string'
    },
    {
      name: 'chacraSueloLimitanteId',
      alias: 'Id suelo limitante',
      type: 'string'
    },
    {
      name: 'chacraSueloAsignadoDsc',
      alias: 'Desc. suelo elegido',
      type: 'string'
    },
    {
      name: 'chacraSueloLimitanteDsc',
      alias: 'Desc. suelo limitante',
      type: 'string'
    },
    {
      name: 'chacraSueloAsignadoTolerancia',
      alias: 'Tolerancia suelo elegido',
      type: 'double'
    },
    {
      name: 'chacraSueloLimitanteTolerancia',
      alias: 'Tolerancia suelo limitante',
      type: 'string'
    },

    {name: 'chacraLargoAsignado', alias: 'Largo elegido', type: 'double'},
    {name: 'chacraLargoLimitante', alias: 'Largo limitante', type: 'double'},
    {
      name: 'chacraPendienteAsignado',
      alias: 'Pendiente elegido',
      type: 'double'
    },
    {
      name: 'chacraPendienteLimitante',
      alias: 'Pendiente limitante',
      type: 'double'
    },
  ],
  renderer: {
    type: 'simple',
    symbol: {
      type: 'simple-fill',
      color: MapLayerColor.chacraFill,
      style: 'solid',
      outline: {
        type: 'simple-line',
        color: MapLayerColor.chacraOutline,
        width: '1px'
      }
    }
  },
  labelingInfo: {
    symbol: LABELING_INFO_SYMBOL,
    labelExpressionInfo: {
      expression: '$feature.chacraNro + " - " + $feature.chacraNombre'
    }
  },
  graphicAttr: GRAPHIC_ATTRS.CHACRA,
  attrId: GRAPHIC_ATTR_IDS.CHACRA,
  exportable: true,
  tools: [MapTool.polygon, MapTool.circle]
};

export const CHACRAS_CORE_LAYER: FeatureLayerProperties = {
  name: '',
  title: '',
  objectIdField: OBJECTID,
  geometryType: null,
  spatialReference: {wkid: 4326},
  outFields: ['*'],
  fields: [
    {name: 'graphicAttr', alias: 'Graphic Attr Type', type: 'string'},
    {name: 'featureName', alias: 'Feature Name', type: 'string'},
    {name: 'id', alias: 'Id', type: 'string'},
    {name: 'idUnico', alias: 'Id Unico', type: 'string'},
  ],
  renderer: {
    type: 'simple',
    symbol: {
      type: 'simple-fill',
      color: MapLayerColor.chacraFill,
      style: 'solid',
      outline: {
        type: 'simple-line',
        color: MapLayerColor.chacraOutline,
        width: '1px'
      }
    }
  },
  labelingInfo: {
    symbol: LABELING_INFO_SYMBOL,
    labelExpressionInfo: {
      expression: '$feature.id'
    }
  },
  graphicAttr: GRAPHIC_ATTRS.CHACRA,
  attrId: GRAPHIC_ATTR_IDS.CHACRA,
  exportable: true,
  tools: [MapTool.polygon, MapTool.point],
  popupTemplate: {
    title: "Datos de {featureName} - {id}",
    content: [{
      type: "fields", // Autocasts as new FieldsContent()
      // Autocasts as new FieldInfo[]
      fieldInfos: [
        {
          fieldName: "id",
          label: "Id",
          // Autocasts as new FieldInfoFormat()
          format: {
            digitSeparator: true
          }
        },
        {
          fieldName: "featureName",
          label: "Tipo",
        }
      ]
    }]
  }
};

export const AGLUTINADOR_POINT_LAYER: FeatureLayerProperties = {
  ...CHACRAS_CORE_LAYER,
  name: ChacraGeoFrom.AGLUTINADOR_POINT,
  title: 'Aglutinador punto',
  geometryType: DibujoType.POINT,
};

export const AGLUTINADOR_POLYGON_LAYER: FeatureLayerProperties = {
  ...CHACRAS_CORE_LAYER,
  name: ChacraGeoFrom.AGLUTINADOR_POLYGON,
  title: 'Aglutinador poligono',
  geometryType: DibujoType.POLYGON,
};

export const AGLUTINADOR_PADRON_LAYER: FeatureLayerProperties = {
  ...CHACRAS_CORE_LAYER,
  name: ChacraGeoFrom.AGLUTINADOR_PADRON,
  title: 'Aglutinador padron',
  geometryType: DibujoType.POLYGON,
};

export const ASEGURADORA_POINT_LAYER: FeatureLayerProperties = {
  ...CHACRAS_CORE_LAYER,
  name: ChacraGeoFrom.ASEGURADORA_POINT,
  title: 'Aseguradora punto',
  geometryType: DibujoType.POINT,
};

export const ASEGURADORA_POLYGON_LAYER: FeatureLayerProperties = {
  ...CHACRAS_CORE_LAYER,
  name: ChacraGeoFrom.ASEGURADORA_POLYGON,
  title: 'Aseguradora poligono',
  geometryType: DibujoType.POLYGON,
};

export const ASEGURADORA_PADRON_LAYER: FeatureLayerProperties = {
  ...CHACRAS_CORE_LAYER,
  name: ChacraGeoFrom.ASEGURADORA_PADRON,
  title: 'Aseguradora padron',
  geometryType: DibujoType.POLYGON,
};
